import { useCompanyData } from '~/data/company/useCompanyData';
import { UseDialogStateOutput, useDialogState } from '~/hooks/useDialogState';

type UseSendMessageToHRDialogOutput = {
  isAvailable: boolean;
  isDisabled: boolean;
  messageContacts: string[] | undefined;
  onOpen: UseDialogStateOutput['open'];
  dialogProps: {
    open: UseDialogStateOutput['isOpen'];
    onClose: UseDialogStateOutput['close'];
  };
};

export const useSendMessageToHRDialog = (): UseSendMessageToHRDialogOutput => {
  const { isOpen, open, close } = useDialogState();
  const { companyData, isLoading, failedToLoad } = useCompanyData();

  const messageContacts = companyData?.config?.fComHrGeneralContacts;

  return {
    messageContacts,
    isAvailable: !!messageContacts && messageContacts.length > 0,
    isDisabled: isLoading || failedToLoad,
    onOpen: open,
    dialogProps: {
      open: isOpen,
      onClose: close,
    },
  };
};
